import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/Login/Login';
import AdminLayout from './components/Admin/AdminLayout';
import DashboardHome from './components/Admin/DashboardHome';
import TracksManagement from './components/Admin/TracksManagement';
import UploadTrack from './components/Admin/UploadTrack';
import UsersManagement from './components/Admin/UsersManagement';
import Settings from './components/Admin/Settings';
import TTSQueue from './components/Admin/TTSQueue';
import Scheduler from './components/Admin/Scheduler';
import AnnouncementHistory from './components/Admin/AnnouncementHistory';
import NewsManager from './components/Admin/NewsManager';
import WeatherManager from './components/Admin/WeatherManager';
import MusicPromptGenerator from './components/Admin/MusicPromptGenerator';
import RadioPlayer from './components/RadioPlayer/RadioPlayer';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      color: 'white',
      fontSize: '20px'
    }}>Loading...</div>;
  }
  
  return isAuthenticated ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<RadioPlayer />} />
          <Route path="/login" element={<Login />} />
          <Route 
            path="/admin" 
            element={
              <PrivateRoute>
                <AdminLayout />
              </PrivateRoute>
            }
          >
            <Route index element={<DashboardHome />} />
            <Route path="tracks" element={<TracksManagement />} />
            <Route path="upload" element={<UploadTrack />} />
            <Route path="tts" element={<TTSQueue />} />
            <Route path="announcements" element={<AnnouncementHistory />} />
            <Route path="scheduler" element={<Scheduler />} />
            <Route path="news" element={<NewsManager />} />
            <Route path="weather" element={<WeatherManager />} />
            <Route path="music-prompt" element={<MusicPromptGenerator />} />
            <Route path="users" element={<UsersManagement />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
